import { Routes } from '@angular/router';
import { AuthGuardService } from './service/auth.guard.service';
import { LoginGuardService } from './service/login.guard.service';
import { adminGuard } from './service/admin.guard.service';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then((m) => m.Login),
    canActivate: [LoginGuardService],
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard').then((m) => m.Dashboard),
    canActivate: [AuthGuardService],
    children: [
      {
        path: '', // Empty path = default child
        loadComponent: () =>
          import('./pages/dashboard/dashboard-home/dashboard-home').then((m) => m.DashboardHome),
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/dashboard/profile/profile').then((m) => m.Profile),
      },
      {
        path: 'settings',
        loadComponent: () => import('./pages/dashboard/settings/settings').then((m) => m.Settings),
        canActivate: [adminGuard], // Only ADMIN and SUPER_ADMIN can access settings
      },
      {
        path: 'chat',
        loadComponent: () =>
          import('./pages/dashboard/dashboard-chat/dashboard-chat').then((m) => m.DashboardChat),
      },
    ],
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login' },
];
